if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header'
				stickyHeader.setAttribute('data-js-inert', '');
				stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
					${this.querySelector('.header__bottom').innerHTML}
				</div>
				<div class="site-header header__top container--large">
					${this.querySelector('.header__top').innerHTML}
				</div>`;
				document.body.append(stickyHeader);

				if ( this.querySelector('.button--cart-handle') && stickyHeader.querySelector('.header-actions') ) {
					stickyHeader.querySelector('.header-actions').append(this.querySelector('.button--cart-handle').cloneNode(true));
				}

				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('[aria-controls]').forEach(elm=>{
					if ( ! ( elm.hasAttribute('data-js-sidebar-handle') || elm.hasAttribute('data-modal') ) ) {
						elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
					}
				})

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				this.SCROLL_StickyHelper = () =>{
					
					var st = window.scrollY;
					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.classList.remove('show');
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;	

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.classList.remove('show');

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							if ( ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top ) < -100 ) {
								stickyHeader.classList.add('show');
							}

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
						}

					} 

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});

				stickyHeader.querySelectorAll('.submenu-masonry').forEach(elm=>{
					if ( Macy ) {
						let columns = 4;
						if ( elm.classList.contains('with-2-promotions') ) {
							columns = 2;
						} else if ( elm.classList.contains('with-promotion') ) {
							columns = 3;
						}
						if ( elm.dataset.columns ) {
							columns = parseInt(elm.dataset.columns);
						}
						const submenuMacy = new Macy({
							container: elm,
							columns: columns
						});
						setTimeout(()=>{
							submenuMacy.reInit();
						}, 100);
					}
				});
				
			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							window.lastFocusedElm = elm;
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( window.lastFocusedElm ) {
							setTimeout(()=>{
								window.lastFocusedElm.focus();
								window.lastFocusedElm = null;
							}, 100);
						}
					}
				});
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
						if ( window.lastFocusedElm ) {
							window.lastFocusedElm.focus();
							window.lastFocusedElm = null;
						}
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Inert elements

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						window.lastFocusedElm = elm;
					}
				})
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				elm.addEventListener('mouseover', ()=>{
					if ( elm.querySelector('.normal-menu') ) {
						elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
					}
				})
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(elm=>{
					elm.addEventListener('focus', ()=>{
						document.getElementById(elm.dataset.jsFocusOverlay).classList.add('active');
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
					})
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.TAB ) {
							if ( document.getElementById('search-results-overlay-desktop').classList.contains('active') ) {
								document.getElementById('search-results-overlay-desktop').classList.remove('active');
							}
						}
					})
				})
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				elm.addEventListener('touchstart', ()=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					elm.classList.toggle('focus');
					babyMenuTouch = true;
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				}, { passive:true });
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					elm.addEventListener('touchstart', ()=>{
						elm.firstElementChild.style.pointerEvents = 'none';
						if ( ! babyMenuTouch ) {
							elm.classList.toggle('focus');
							closeTouchSubmenus(elm);
						}
						babyMenuTouch = false;
					}, { passive:true });
				}
			})

			// keyboard and tab navigation for the menu

			const topLevelMenuItems = Array.from(document.querySelectorAll('.site-nav.style--classic .has-submenu'));
			const topLevelMenuLinks = topLevelMenuItems
				.map(elm => elm.querySelector(':scope > a'))
				.filter(Boolean);

			const getVisibleFocusableItems = (container) => {
				return Array.from(container.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(elm => {
					return elm.offsetParent !== null;
				});
			}

			const closeBabyMenus = (menuElm) => {
				menuElm.querySelectorAll('.has-babymenu.focus').forEach(babyElm => {
					babyElm.classList.remove('focus');
					const babyLink = babyElm.querySelector(':scope > a');
					if ( babyLink ) {
						babyLink.setAttribute('aria-expanded', 'false');
					}
				});
			}

			const closeTopLevelMenu = (menuElm) => {
				menuElm.classList.remove('focus');
				const topLink = menuElm.querySelector(':scope > a');
				if ( topLink ) {
					topLink.setAttribute('aria-expanded', 'false');
				}
				closeBabyMenus(menuElm);
			}

			const closeTopLevelMenus = (exceptElm = null) => {
				topLevelMenuItems.forEach(menuElm => {
					if ( menuElm !== exceptElm ) {
						closeTopLevelMenu(menuElm);
					}
				});
			}

			const openTopLevelMenu = (menuElm) => {
				menuElm.classList.add('focus');
				const topLink = menuElm.querySelector(':scope > a');
				if ( topLink ) {
					topLink.setAttribute('aria-expanded', 'true');
				}
			}

			const focusSiblingTopLevelLink = (currentLink, step) => {
				const currentIndex = topLevelMenuLinks.indexOf(currentLink);
				if ( currentIndex === -1 || topLevelMenuLinks.length <= 1 ) {
					return;
				}
				const targetIndex = (currentIndex + step + topLevelMenuLinks.length) % topLevelMenuLinks.length;
				const targetLink = topLevelMenuLinks[targetIndex];
				closeTopLevelMenus();
				targetLink.focus();
			}

			document.addEventListener('click', e=>{
				if ( ! e.target.closest('.site-nav.style--classic') ) {
					closeTopLevelMenus();
				}
			});

			topLevelMenuItems.forEach(elm=>{
				const childEl = elm.querySelector(':scope > a');
				const submenuElm = elm.querySelector(':scope > .submenu');

				if ( ! childEl ) {
					return;
				}

				const toggleTopLevelMenu = () => {
					const willOpen = ! elm.classList.contains('focus');
					closeTopLevelMenus(elm);
					if ( willOpen ) {
						openTopLevelMenu(elm);
					} else {
						closeTopLevelMenu(elm);
					}
					return willOpen;
				}

				const focusSubmenuEdgeItem = (toLast = false) => {
					if ( ! submenuElm ) {
						return;
					}
					const submenuItems = getVisibleFocusableItems(submenuElm);
					if ( submenuItems.length ) {
						(toLast ? submenuItems[submenuItems.length - 1] : submenuItems[0]).focus();
					}
				}

				childEl.addEventListener('click', e=>{
					e.preventDefault();
					toggleTopLevelMenu();
				});

				childEl.addEventListener('keydown', e=>{
					if ( e.key === 'Enter' || e.key === ' ' ) {
						e.preventDefault();
						toggleTopLevelMenu();
					} else if ( e.key === 'Tab' && ! e.shiftKey ) {
						closeTopLevelMenus(elm);
						openTopLevelMenu(elm);
					} else if ( e.key === 'ArrowDown' ) {
						e.preventDefault();
						closeTopLevelMenus(elm);
						openTopLevelMenu(elm);
						focusSubmenuEdgeItem(false);
					} else if ( e.key === 'ArrowUp' ) {
						e.preventDefault();
						closeTopLevelMenus(elm);
						openTopLevelMenu(elm);
						focusSubmenuEdgeItem(true);
					} else if ( e.key === 'ArrowRight' ) {
						e.preventDefault();
						focusSiblingTopLevelLink(childEl, 1);
					} else if ( e.key === 'ArrowLeft' ) {
						e.preventDefault();
						focusSiblingTopLevelLink(childEl, -1);
					} else if ( e.key === 'Escape' ) {
						e.preventDefault();
						closeTopLevelMenu(elm);
						childEl.focus();
					}
				});

				elm.addEventListener('focusout', ()=>{
					setTimeout(() => {
						if ( ! elm.contains(document.activeElement) ) {
							closeTopLevelMenu(elm);
						}
					}, 10);
				});

				if ( submenuElm ) {
					submenuElm.addEventListener('keydown', e=>{
						const activeLink = e.target.closest('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
						if ( ! activeLink ) {
							return;
						}

						const submenuItems = getVisibleFocusableItems(submenuElm);
						const currentIndex = submenuItems.indexOf(activeLink);

						if ( e.key === 'ArrowDown' || e.key === 'ArrowUp' ) {
							if ( currentIndex === -1 || submenuItems.length === 0 ) {
								return;
							}
							e.preventDefault();
							const step = e.key === 'ArrowDown' ? 1 : -1;
							const targetIndex = (currentIndex + step + submenuItems.length) % submenuItems.length;
							submenuItems[targetIndex].focus();
						} else if ( e.key === 'Escape' ) {
							e.preventDefault();
							closeTopLevelMenu(elm);
							childEl.focus();
						}
					});
				}
			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	
				const elm = childEl.parentNode;
				const babyMenuElm = elm.querySelector(':scope > .babymenu');

				const toggleBabyMenu = () => {
					const isOpen = elm.classList.toggle('focus');
					childEl.setAttribute('aria-expanded', String(isOpen));
					return isOpen;
				}

				const closeBabyMenu = () => {
					elm.classList.remove('focus');
					childEl.setAttribute('aria-expanded', 'false');
				}

				const focusBabyEdgeItem = (toLast = false) => {
					if ( ! babyMenuElm ) {
						return;
					}
					const babyMenuItems = getVisibleFocusableItems(babyMenuElm);
					if ( babyMenuItems.length ) {
						(toLast ? babyMenuItems[babyMenuItems.length - 1] : babyMenuItems[0]).focus();
					}
				}

				childEl.addEventListener('click', e=>{
					e.preventDefault();
					toggleBabyMenu();
				});

				childEl.addEventListener('keydown', e=>{
					if ( e.key === 'Enter' || e.key === ' ' ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						toggleBabyMenu();
					} else if ( e.key === 'ArrowRight' || e.key === 'ArrowDown' ) {
						e.preventDefault();
						if ( ! elm.classList.contains('focus') ) {
							toggleBabyMenu();
						}
						focusBabyEdgeItem(false);
					} else if ( e.key === 'ArrowLeft' || e.key === 'Escape' ) {
						e.preventDefault();
						closeBabyMenu();
						childEl.focus();
					}
				});

				elm.addEventListener('focusout', ()=>{
					setTimeout(() => {
						if ( ! elm.contains(document.activeElement) ) {
							closeBabyMenu();
						}
					}, 10);
				});

				if ( babyMenuElm ) {
					babyMenuElm.addEventListener('keydown', e=>{
						const activeLink = e.target.closest('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
						if ( ! activeLink ) {
							return;
						}

						const babyMenuItems = getVisibleFocusableItems(babyMenuElm);
						const currentIndex = babyMenuItems.indexOf(activeLink);

						if ( e.key === 'ArrowDown' || e.key === 'ArrowUp' ) {
							if ( currentIndex === -1 || babyMenuItems.length === 0 ) {
								return;
							}
							e.preventDefault();
							const step = e.key === 'ArrowDown' ? 1 : -1;
							const targetIndex = (currentIndex + step + babyMenuItems.length) % babyMenuItems.length;
							babyMenuItems[targetIndex].focus();
						} else if ( e.key === 'ArrowLeft' || e.key === 'Escape' ) {
							e.preventDefault();
							closeBabyMenu();
							childEl.focus();
						}
					});
				}
			});

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* * generic hide/show functions 
		*/

		show(){

			this.opened = true;
			this.removeAttribute('aria-hidden');
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			// THJ 2026-09-11: cancel a pending hide() display:none so a quick close/re-open
			// can't blank the drawer, and only apply inert if the drawer is still open when
			// the timer fires. Previously show() then hide() inside 15ms left the header
			// (and everything else marked data-js-inert) permanently inert until a refresh.
			clearTimeout(this._hideTimer);
			clearTimeout(this._showTimer);
			this.style.display = 'grid';
			this._showTimer = setTimeout(()=>{
				if ( ! this.opened ) {
					return;
				}
				this.classList.add('sidebar--opened');
				(window.inertElems || []).forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id == "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){

			this.opened = false;
			clearTimeout(this._showTimer);
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			document.querySelectorAll('[data-js-inert][inert]').forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			clearTimeout(this._hideTimer);
			this._hideTimer = setTimeout(()=>{
				if ( ! this.opened ) {
					this.style.display = 'none';
				}
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

			if ( this.dataset.showHeaderActions == 'true' ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				this.querySelector('nav').prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							window.lastFocusedElm = elm;
						}
					})
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});
				
			}

		}

		_resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.checkNav();
			}, 200));
			this.checkNav();

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') == 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}

/* THJ 2026-09-11: back/forward-cache reset.
   When the browser restores a page from its back/forward cache (Safari and Chrome both do this),
   the page comes back exactly as it was left: if a drawer or modal was open, the header is still
   marked inert and nothing in it responds to clicks. Close anything that was open and clear the
   inert flags so the menu works immediately. */
window.addEventListener('pageshow', e=>{
	if ( ! e.persisted ) {
		return;
	}
	document.querySelectorAll('sidebar-drawer.sidebar--opened').forEach(drawer=>{
		if ( typeof drawer.hide === 'function' ) {
			drawer.hide();
		}
	});
	document.querySelectorAll('modal-box.active').forEach(modal=>{
		if ( typeof modal.hide === 'function' ) {
			modal.hide();
		}
	});
	document.querySelectorAll('[data-js-inert][inert]').forEach(elm=>{
		elm.removeAttribute('inert');
	});
	document.querySelectorAll('.site-nav.style--classic li.focus').forEach(elm=>{
		elm.classList.remove('focus');
		elm.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
	});
});

/* instantpage.js script
   THJ 2026-09-11: wrapped in a function so its variables (prefetcher, isSupported, preload, ...)
   are private. As bare top-level let/const they were global names: if any app script on the page
   declared the same name first, this whole file would fail to run ("Identifier has already been
   declared") and the header, drawers and menu would never initialise on that page load. */
(function(){
let urlToPreload,mouseoverTimer,lastTouchTimestamp;const prefetcher=document.createElement("link"),isSupported=prefetcher.relList&&prefetcher.relList.supports&&prefetcher.relList.supports("prefetch"),isDataSaverEnabled=navigator.connection&&navigator.connection.saveData,allowQueryString="instantAllowQueryString"in document.body.dataset,allowExternalLinks="instantAllowExternalLinks"in document.body.dataset;if(isSupported&&!isDataSaverEnabled){prefetcher.rel="prefetch",document.head.appendChild(prefetcher);const e={capture:!0,passive:!0};document.addEventListener("touchstart",touchstartListener,e),document.addEventListener("mouseover",mouseoverListener,e)}function touchstartListener(e){lastTouchTimestamp=performance.now();const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("touchcancel",touchendAndTouchcancelListener,{passive:!0}),t.addEventListener("touchend",touchendAndTouchcancelListener,{passive:!0}),urlToPreload=t.href,preload(t.href))}function touchendAndTouchcancelListener(){urlToPreload=void 0,stopPreloading()}function mouseoverListener(e){if(performance.now()-lastTouchTimestamp<1100)return;const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("mouseout",mouseoutListener,{passive:!0}),urlToPreload=t.href,mouseoverTimer=setTimeout(()=>{preload(t.href),mouseoverTimer=void 0},65))}function mouseoutListener(e){e.relatedTarget&&e.target.closest("a")==e.relatedTarget.closest("a")||(mouseoverTimer?(clearTimeout(mouseoverTimer),mouseoverTimer=void 0):(urlToPreload=void 0,stopPreloading()))}function isPreloadable(e){if(!e||!e.href)return;if(urlToPreload==e.href)return;const t=new URL(e.href);return!(!(allowExternalLinks||t.origin==location.origin||"instant"in e.dataset)||!["http:","https:"].includes(t.protocol)||"http:"==t.protocol&&"https:"==location.protocol||!(allowQueryString||!t.search||"instant"in e.dataset)||t.hash&&t.pathname+t.search==location.pathname+location.search||"noInstant"in e.dataset)||void 0}function preload(e){prefetcher.href=e}function stopPreloading(){prefetcher.removeAttribute("href")}

})();
